import { Outlet } from "react-router-dom";
import { ActionIcon, AppShell, Flex } from "@mantine/core";
import { Sidebar } from "../../components/sidebar";
import { MdOutlineMenu } from "react-icons/md";
import { useDisclosure } from "@mantine/hooks";
import { useAuthContext } from "../../loginContext";
import { useLogin } from "../../authConfig";
import { Login } from "../../components/login";
import { ENVIRONMENT_BANNER_HEIGHT, EnvironmentBanner, useNonProdEnvironment } from "../../components/environment-banner/EnvironmentBanner";

const Layout = () => {
    const [isSidebarOpened, { toggle }] = useDisclosure(false);
    const { isLoggedIn } = useAuthContext();
    const nonProdEnvironment = useNonProdEnvironment();

    if (isLoggedIn || !useLogin) {
        return (
            <AppShell
                layout="alt"
                header={{ height: ENVIRONMENT_BANNER_HEIGHT, collapsed: !nonProdEnvironment }}
                navbar={{ width: 300, breakpoint: "sm", collapsed: { mobile: !isSidebarOpened, desktop: !isSidebarOpened } }}
            >
                {nonProdEnvironment && (
                    <AppShell.Header withBorder={false}>
                        <EnvironmentBanner environment={nonProdEnvironment} />
                    </AppShell.Header>
                )}
                <AppShell.Navbar>
                    <Sidebar toggle={toggle}></Sidebar>
                </AppShell.Navbar>
                <AppShell.Main
                    display="flex"
                    px="md"
                    pb="md"
                    style={{
                        flexDirection: "column",
                        height: "100%",
                        paddingTop: "calc(var(--app-shell-header-offset, 0px) + var(--mantine-spacing-md))"
                    }}
                >
                    <ActionIcon variant="transparent" color="dark.6" onClick={toggle} style={isSidebarOpened ? { visibility: "hidden" } : {}}>
                        <MdOutlineMenu size={34} />
                    </ActionIcon>
                    <Flex flex={1} display="flex" direction="column" style={{ height: "100%" }}>
                        <Outlet />
                    </Flex>
                </AppShell.Main>
            </AppShell>
        );
    }
    return <Login />;
};

export default Layout;
